export default "__VITE_ASSET__DHXbrIzu__"